import type { RunMetricOutput } from "@/types/RunMetricOutput"

import { NumericalMetricRecord } from "../base/NumericalMetricRecord"
import { WithAudioGateMixin } from "../mixins/WithAudioGateMixin"

/** Convert seconds → mm:ss (no hours) */
const fmt = (sec: number) => {
  const m = Math.floor(sec / 60)
    .toString()
    .padStart(1, "0")
  const s = Math.floor(sec % 60)
    .toString()
    .padStart(2, "0")
  return `${m}:${s}`
}

export class AudioDurationMetricRecord extends WithAudioGateMixin(
  NumericalMetricRecord,
) {
  overviewSize = "small" as const
  aggregate_units = "s"

  protected _formatValue(v: number): string {
    return fmt(v)
  }

  getHeaderValue(mo: RunMetricOutput[]): string | null {
    const valid = mo.filter((m) => m.float_value !== null)
    if (valid.length === 0) {
      return null
    }
    const average =
      valid.map((m) => m.float_value as number).reduce((a, b) => a + b, 0) /
      valid.length
    return fmt(average)
  }

  getSingleMetricOutputNode(mo: RunMetricOutput): React.ReactNode | null {
    if (mo.float_value === null) {
      return <div>N/A</div>
    }
    return (
      <div className="text-2xl text-foreground font-semibold">
        {fmt(mo.float_value)}
      </div>
    )
  }

  _renderDeepDive(): React.ReactNode {
    return null
  }
}
